export default __webpack_public_path__ + "6b84ef3.png";